// ----------------------------------------------------
// src/Redux/Slices/ServiceSlice.js
// ----------------------------------------------------

import { createSlice } from "@reduxjs/toolkit";
import ServicesData from "../../Json/ServicesData.json";

const initialState = {
  services: ServicesData,
};

const serviceSlice = createSlice({
  name: "services",
  initialState,
  reducers: {},
});

export default serviceSlice.reducer;